import { useSelector } from 'react-redux';

import { matrixSelector } from '../../slices/matrixSlice';
import { appSelector } from '../../slices/appSlice';

const AddToCart = ({ trackingRef }) => {
    const {
      baseUrl,
      code,
      productId: product,
      webproductId: webproduct,
      currentOptions,
      prices: {
        values: priceValues,
        selection_quantity: selectionQuantity,
        selection_number_of_single_products: selectionNumberOfSingleProducts,
        labels: priceLabels,
      },
      media,
      productTags: product_tags,
    } = useSelector(matrixSelector);
    const { ajaxCart, headline, subHeadline } = useSelector(appSelector);

    const { quantity: qty } = priceValues.find(p => p.is_selected);

    const dispatchFormElements = {
      product,
      webproduct,
      qty,
      product_tags,
      current_selection_id: `prod_${product}_${(new Date().getTime())}_${Math.floor(Math.random() * 100)}`,
      [`print_options[PP][]`]: code,
    };
    const cartPath = '/pickAndMix/product/addToCart';

    let disableButton = false;
    const btnAttributes = {
      variant: '1',
      full: true,
      size: 'big'
    }

    for (const currentOption of currentOptions) {
      const { id, value, is_product_part, is_out_of_stock } = currentOption;

      if (is_product_part) {
        dispatchFormElements[`print_options[PP_${code}][${id}][]`] = value;
      }
      else {
        dispatchFormElements[`print_options[${id}][${id}][]`] = value;
      }

      if (is_out_of_stock) {
        disableButton = true;
        btnAttributes.disabled = true;
      }
    }

    const buildAdditionalInfo = () => {
      if (!selectionQuantity || !priceLabels) return '';

      const quantityLabel = selectionQuantity === 1
        ? priceLabels.singular_price_label
        : priceLabels.plural_price_label;
      let info = `${selectionQuantity.toLocaleString()} ${quantityLabel}`;

      if (selectionNumberOfSingleProducts > 0) {
        const productLabel = selectionNumberOfSingleProducts === 1
          ? priceLabels.singular_product_label
          : priceLabels.plural_product_label;
        info += ` (${selectionNumberOfSingleProducts.toLocaleString()} ${productLabel})`;
      }

      return info;
    };

    const handleAjaxCart = ({ currentTarget: trigger }) => {
      if (trackingRef.current?.trackFinishConfigurator) {
        trackingRef.current.trackFinishConfigurator();
      }

      const event = new CustomEvent('alpine-ajax-cart-add', {
        detail: {
          path: cartPath,
          trigger,
          content: {
            headline,
            subHeadline,
            imagePath: media[0].image,
            additionalInfo: buildAdditionalInfo(),
          },
          payload: dispatchFormElements,
        },
      });

      window.dispatchEvent(event);
    };

    return (
      <Choose>
        <When condition={ajaxCart}>
          <ft-button
            class='button-configurator-completed'
            data-testid = {process.env.RENDER_TESTIDS ? "add-to-cart-button" : undefined}
            onClick={handleAjaxCart}
            {...btnAttributes}
          >
            {Drupal.t('Add to basket')}
          </ft-button>
        </When>
        <Otherwise>
          <form
            method='POST'
            action={`${baseUrl}${cartPath}`}
            encType='multipart/form-data'
          >
            {Object.keys(dispatchFormElements).map(key => {
              return (
                <input
                  key={key}
                  type='hidden'
                  name={key}
                  value={dispatchFormElements[key] ? dispatchFormElements[key] : ''}
                />
              );
            })}
            <input className='button-configurator-completed' type='submit' value='Add to Cart' disabled={disableButton} />
          </form>
        </Otherwise>
      </Choose>

    );
  }
;

export default AddToCart;
